import React, { useEffect } from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <section className="privacy-policy-page">
      <div className="privacy-policy-header">
        <h1 className="privacy-policy-title"><span>Privacy </span>Policy</h1>
        <p className="privacy-policy-update-date"><span>Last Updated: 08/04/2025</span></p>
      </div>

      <div className="privacy-policy-content">
        <p>
          At Mahadev Book Official, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains what data we collect, how we use it, and your choices regarding your information.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Personal Information:</strong> Name, email, contact number, and date of birth during account registration.</li>
          <li><strong>Financial Information:</strong> Payment details used for deposits and withdrawals.</li>
          <li><strong>Usage Data:</strong> Information related to your activity on our platform—games played, bets placed, and navigation patterns.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li><strong>Account Management:</strong> To verify your identity, maintain your account, and provide customer support.</li>
          <li><strong>Transactions:</strong> To securely process deposits, bets, and withdrawals.</li>
          <li><strong>Improving Services:</strong> To enhance your experience and tailor content based on user behavior.</li>
          <li><strong>Communication:</strong> To send updates, offers, and account-related alerts.</li>
        </ul>

        <h2>3. Data Security</h2>
        <p>
          We use encryption and regular security audits to protect your data from unauthorized access or misuse.
        </p>

        <h2>4. Third-Party Sharing</h2>
        <p>
          We may share your data with trusted third-party services for payment processing and marketing. We do not sell or disclose your information without consent.
        </p>

        <h2>5. Cookies & Tracking</h2>
        <p>
          Cookies help us enhance your browsing experience. You can modify cookie settings through your browser at any time.
        </p>

        <h2>6. Your Choices</h2>
        <p>
          You may request to view, update, or delete your personal information. You can also manage your communication preferences.
        </p>

        <h2>7. Policy Updates</h2>
        <p>
          This policy may be updated periodically. Continued use of the platform constitutes acceptance of any changes.
        </p>

        <p>
          For questions or concerns, feel free to contact us via WhatsApp at <a href={ContactLink}>+91 8888568888</a>.
        </p>

        <p style={{ color: "#DAA520" }}>
          Thank you for choosing Mahadev Book Official. Your trust drives our commitment to keeping your data safe and your experience seamless.
        </p>
      </div>

      <div className="privacy-btn">
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          WhatsApp Us @ 8888988880
        </a>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
